<div class="row">
  <ng-container *ngFor="let field of formConfig">
      <app-dynamic-field
        class="{{field.class}}"
        [field]="field"
        (requiredKey)="catchRequiredList($event)"
        (selecteditem)="CollectEmit($event)"
        (selectedItems)="CollectCheckbox($event)"
        (reloadOptions)="reloadSelectItems($event)">
      </app-dynamic-field>
  </ng-container>
</div>